import { css } from 'emotion';
import { pink } from 'inside-out/global-styles';

export const linkStyle = css({
	fontWeight: 500,
	color: pink,
	textDecoration: 'none',
	fontSize: '16px',
	lineHeight: '24px',
	'& svg': {
		verticalAlign: 'initial',
		marginLeft: '10px',
	},
	'@media print': {
		display: 'none',
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/arrowLink/styles.js